export const SET_OFFLINE = 'connectivity/SET_OFFLINE';
export const SET_ONLINE = 'connectivity/SET_ONLINE';
